import { VerticalRectangleWithCustomRadius } from './VerticalRectangleWithCustomRadius';
import {
  BAR_BOTTOM_RADIUS,
  BAR_TOP_LEFT_RADIUS,
  SMALL_BAR_RADIUS,
  getTopRightRadius,
} from './constants';

// if one bar has an image, all bars must be of the same height
// meaning that they need to take the height of the image into account even if they don't have an image
// in that case there is the imageUrl property but it is undefined
type BarImage = { imageUrl: string | undefined } | undefined;

interface Bar {
  color: string;
  x: number;
  y: number;
  width: number;
  height: number;
  image?: BarImage;
  opacity?: number;
  disableAnimations?: boolean;
  animationDelay?: number;
}

export const Bar = ({
  color,
  x,
  y,
  width,
  height,
  image,
  opacity = 1,
  disableAnimations = false,
  animationDelay = 0,
}: Bar) => {
  const topRightRadius = getTopRightRadius(width);
  const colorRectangleHeight = height;

  if (image) {
    const imageHeight = width;
    const imageWidth = width;

    const colorRectangleY = y;

    return (
      <>
        <VerticalRectangleWithCustomRadius
          data-testid="image-rectangle"
          background={image.imageUrl ? { image: image.imageUrl } : { color }}
          x={x}
          y={colorRectangleY - imageHeight}
          width={imageWidth}
          height={imageHeight}
          topRightRadius={topRightRadius}
          topLeftRadius={BAR_TOP_LEFT_RADIUS}
          animateFromY={
            // initialY of the bar below - imageHeight
            // const initialY = y + height - maxTotalVerticalRadius;
            colorRectangleY +
            colorRectangleHeight -
            BAR_BOTTOM_RADIUS -
            imageHeight
          }
          disableAnimations={disableAnimations}
          opacity={opacity}
          animationDelay={animationDelay}
        />
        <VerticalRectangleWithCustomRadius
          data-testid="color-rectangle"
          background={{ color }}
          x={x}
          y={colorRectangleY}
          width={width}
          height={colorRectangleHeight}
          bottomLeftRadius={BAR_BOTTOM_RADIUS}
          bottomRightRadius={BAR_BOTTOM_RADIUS}
          disableAnimations={disableAnimations}
          opacity={opacity}
          animationDelay={animationDelay}
        />
      </>
    );
  }

  const minPossibleHeightForPath = topRightRadius + BAR_BOTTOM_RADIUS;
  const canRenderPathWithBigTopRadius =
    colorRectangleHeight >= minPossibleHeightForPath;

  const radii = canRenderPathWithBigTopRadius
    ? {
        topRightRadius,
        topLeftRadius: BAR_TOP_LEFT_RADIUS,
        bottomLeftRadius: BAR_BOTTOM_RADIUS,
        bottomRightRadius: BAR_BOTTOM_RADIUS,
      }
    : {
        topRightRadius: SMALL_BAR_RADIUS,
        topLeftRadius: SMALL_BAR_RADIUS,
        bottomLeftRadius: SMALL_BAR_RADIUS,
        bottomRightRadius: SMALL_BAR_RADIUS,
      };

  return (
    <VerticalRectangleWithCustomRadius
      data-testid="rectangle"
      background={{ color }}
      x={x}
      y={y}
      width={width}
      height={colorRectangleHeight}
      {...radii}
      disableAnimations={disableAnimations}
      opacity={opacity}
      animationDelay={animationDelay}
    />
  );
};
